<script>
    import {createEventDispatcher} from "svelte"
    export let disabled=false;
    export let isLoading=false;
    export let buttonClass="btn-primary";
    export let buttonText="";
    export let title="";
    export let dataid="";
    export let style="min-width:82px;min-height:35px;";
    export let confirmButtonStyle="width:147.5px;";
    export let popupText="";
    export let popupTitle="";
    export let isConfirm = false;
    export let isExportTest = false;
    export let placement ='right';
    export let loadingText = '';
    export let hoverText = '';
    import { popupAction } from '../../components/popup-action.js';

    const dispatch = new createEventDispatcher();
    
</script>

{#if isConfirm}
  <button
      data={dataid}
      class="btn {buttonClass} float-left"
      style={confirmButtonStyle}
      disabled={disabled || isLoading}
      data-toggle="confirmation"        
      data-content ={hoverText}           
      use:popupAction={{
          rootSelector: '[data-toggle=confirmation]', 
          singleton: true,
          popout: true,
          placement:`${placement}`,     
          title: `${popupTitle}`,
          template:`<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-header"></h3><div class="popover-body">${popupText}<div class="confirmation-buttons text-center">
            <div class="btn-group"><a href="#" class="h-100 d-flex align-items-center btn btn-sm btn-secondary mr-2">No</a><a href="#" class="h-100 d-flex align-items-center btn btn-sm btn-primary">Yes</a></div>
          </div></div></div>`,
          onConfirm : () => { dispatch('confirmPopup') } }} >
      {#if isLoading}
          <span class="spinner-border spinner-border-sm" />
      {:else}{@html buttonText} {/if}
  </button>
{:else if isExportTest}

  <button
    type="button"
    title={title}
    style={style}
    disabled={disabled}
    class="btn {buttonClass}"  
    data={dataid}        
    on:click={()=> dispatch("click")}>
    {#if isLoading}
      {loadingText}
      <span class="spinner-border spinner-border-sm" />
    {:else}
      {@html buttonText}
    {/if}
  </button>

{:else}
  <button
    type="button"
    title={title}
    style={style}
    disabled={disabled ||  isLoading}
    class="btn {buttonClass}"  
    data={dataid}        
    on:click={()=> dispatch("click")}>
    {#if isLoading}
      {loadingText}
      <span class="spinner-border spinner-border-sm" />
    {:else}
      {@html buttonText}
    {/if}
  </button>
{/if}

